import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
const images = [{
  id: 1,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/Photo49.jpg',
  alt: 'Fabric Reality band member'
}, {
  id: 2,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/Photo33.jpg',
  alt: 'Fabric Reality performance'
}, {
  id: 3,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ps3k5nidS8uq9sbbp91Kye/1659642841402_filtered.jpg',
  alt: 'Fabric Reality live performance with purple lighting'
}, {
  id: 4,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/211881920002-scaled-1.jpg',
  alt: 'Fabric Reality artwork'
}, {
  id: 5,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/CNV00006.jpg',
  alt: 'Fabric Reality band member'
}, {
  id: 6,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aoNiK6X7s9SwvUUd4f5yBG/1659642876701_filtered.jpg',
  alt: 'Fabric Reality guitarist performing live'
}, {
  id: 7,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/Photo09_9.jpg',
  alt: 'Fabric Reality studio session'
}, {
  id: 8,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/Photo24_21.jpg',
  alt: 'Fabric Reality artwork'
}, {
  id: 9,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rfd1JqkjnJPrxrGGi1bcdH/1659642927638_filtered.jpg',
  alt: 'Fabric Reality vocalist performing with guitar'
}, {
  id: 10,
  url: 'https://fabricreality.com/wp-content/uploads/2022/09/Photo13_13.jpg',
  alt: 'Fabric Reality band member'
}];
const ImageGallery = () => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const imagesPerPage = 6;
  const totalPages = Math.ceil(images.length / imagesPerPage);
  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const openLightbox = (index: number) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };
  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };
  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % images.length);
    }
  };
  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage - 1 + images.length) % images.length);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % totalPages);
    scrollToTop();
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages);
    scrollToTop();
  };
  const goToPage = (pageIndex: number) => {
    setCurrentPage(pageIndex);
    scrollToTop();
  };
  const displayedImages = images.slice(currentPage * imagesPerPage, (currentPage + 1) * imagesPerPage);
  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (selectedImage === null) return;
      if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'Escape') {
        closeLightbox();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);
  return <section className="pt-28 md:pt-36 pb-16" data-id="element-350">
      <div className="max-w-6xl mx-auto" data-id="element-351">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-352">
          IMAGES
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-353">
          {displayedImages.map((image, index) => <div key={image.id} className="group relative overflow-hidden rounded-xl cursor-pointer transform transition-all duration-500 hover:scale-105 hover:shadow-xl hover:shadow-pink-500/20 border border-purple-500/10 hover:border-purple-500/30" onClick={() => openLightbox(currentPage * imagesPerPage + index)} data-id="element-354">
              <div className="aspect-square bg-black" data-id="element-355">
                <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" data-id="element-356" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-357">
                <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-300" data-id="element-358">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-359">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m4-3H6" data-id="element-360" />
                  </svg>
                </div>
              </div>
            </div>)}
        </div>
        {totalPages > 1 && <div className="flex justify-center mt-12 space-x-6" data-id="element-361">
            <button onClick={prevPage} className="p-3 rounded-full bg-purple-900/50 hover:bg-purple-800/70 text-white transition-colors border border-purple-500/30" data-id="element-362">
              <ChevronLeftIcon size={24} data-id="element-363" />
            </button>
            <div className="flex items-center text-white font-mono" data-id="element-364">
              {Array.from({
            length: totalPages
          }).map((_, index) => <button key={index} onClick={() => goToPage(index)} className={`w-3 h-3 rounded-full mx-1 transition-all ${currentPage === index ? 'bg-pink-500 scale-125' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to page ${index + 1}`} data-id="element-365" />)}
            </div>
            <button onClick={nextPage} className="p-3 rounded-full bg-purple-900/50 hover:bg-purple-800/70 text-white transition-colors border border-purple-500/30" data-id="element-366">
              <ChevronRightIcon size={24} data-id="element-367" />
            </button>
          </div>}
        {selectedImage !== null && <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 backdrop-blur-lg" data-id="element-368">
            <button onClick={closeLightbox} className="absolute top-6 right-6 bg-black/70 p-3 rounded-full text-white hover:bg-black hover:text-pink-400 transition-all z-10" aria-label="Close lightbox" data-id="element-369">
              <XIcon size={24} data-id="element-370" />
            </button>
            <button onClick={prevImage} className="absolute left-6 top-1/2 transform -translate-y-1/2 p-3 rounded-full bg-black/70 text-white hover:bg-black hover:text-pink-400 transition-all z-10" aria-label="Previous image" data-id="element-371">
              <ChevronLeftIcon size={32} data-id="element-372" />
            </button>
            <div className="relative max-w-5xl max-h-[85vh] w-full flex items-center justify-center" data-id="element-373">
              <img src={images[selectedImage].url} alt={images[selectedImage].alt} className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl" data-id="element-374" />
              <div className="absolute bottom-4 left-0 right-0 text-center" data-id="element-375">
                <p className="text-white/70 text-sm bg-black/50 inline-block px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-376">
                  {selectedImage + 1} / {images.length}
                </p>
              </div>
            </div>
            <button onClick={nextImage} className="absolute right-6 top-1/2 transform -translate-y-1/2 p-3 rounded-full bg-black/70 text-white hover:bg-black hover:text-pink-400 transition-all z-10" aria-label="Next image" data-id="element-377">
              <ChevronRightIcon size={32} data-id="element-378" />
            </button>
          </div>}
      </div>
    </section>;
};
export default ImageGallery;